// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.app-container[data-v-0c15a7ef] .el-table__row {\n  font-weight: bold;\n}\n", ""]);
// Exports
module.exports = exports;
